import React, { useState, useEffect, useMemo, useRef } from 'react';
import moment from 'moment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from './Budget.module.css';
import { years } from '../../helpers';
import Select from '../common/YearSelect';
import Accordion from '../Accordion';
import StackedBar from '../Charts/StackedBar';
import DefaultBar from '../Charts/DefaultBar';
import ColorsBar from '../Charts/ColorsBar';
import useAPI from '../../hooks/useAPI';
import { Form } from 'react-bootstrap';
import LoadingTable from '../table/LoadingTable';
import './TabBudget.less';

export default function TabBudget() {
  const [year, setYear] = useState(moment().year());
  const isNew = year >= 2025;
  const [grantCheck, setGrantCheck] = useState(true);
  const [outBudgetCheck, setOutBudgetCheck] = useState(true);
  const api = useAPI();
  const [totals, setTotals] = useState([]);
  const [byTypesState, setByTypesState] = useState();
  const [byDivisionsState, setByDivisionsState] = useState();
  const [isLoadingDivisions, setIsLoadingDivisions] = useState(false);
  const [byAgreements, setByAgreements] = useState([]);
  const [cofinancing, setCofinancing] = useState(null)
  const [isLoaded, setIsLoaded] = useState(true);

  const colorForLabels = {
    firstLevel:'#0A0052',
    secondLevel:'#0A2A9A',
    thirdLevel:'#305FFD',
    fourthLevel:'#7585D1',
    fifthLevel:'#B3B9C8',
    sixthLevel:'#C2D0EE'
  }
  const byTypes = {
    datasets: [
      {
        label: '',
        backgroundColor: '#696969',
        barThickness: 20,
      },
      {
        label: '',
        backgroundColor: '#DDDDDD',
        barThickness: 20,
      },
    ],
  };
  const byDivisions = {
    datasets: [
      {
        label: '',
        backgroundColor: '#0A0052',
        barThickness: 20,
      },
      {
        label: '',
        backgroundColor: '#C2D0EE',
        barThickness: 20,
      },
    ],
  };

  const createDataSet = (label,color) => {
    return {
      label: label,
      data: [0],
      backgroundColor: color,
      barThickness: 70,
    }
  }

  const setDataToDataSet = (datasets,valuesArray) => {
    const copy = [...datasets]
      copy.forEach((element,index) => {
        element.data[0] = Math.trunc(valuesArray[index]) || 0
      })
    return copy
  }

  function splitStringEveryNCharsBySpace(str, n) {
    let result = [];
    let currentLine = '';

    str.split(' ').forEach(word => {
      if ((currentLine + word).length > n) {
        result.push(currentLine.trim());
        currentLine = ''
      }
       currentLine += word + ' ';
    });

    if (currentLine.length > 0) {
      result.push(currentLine.trim());
    }

    return result
  }

  function doByAgreements(data) {
    const res = [];
    data.map((e, i) => {
      const elem = {
        labels: [''],
        datasets: [
            createDataSet('Оплачено',colorForLabels.firstLevel),
            createDataSet('Законтрактовано',colorForLabels.secondLevel),
            createDataSet('Акцептовано ПФУ',colorForLabels.thirdLevel),
            createDataSet('Утверждено средств по закупкам',colorForLabels.fourthLevel),
            createDataSet('Одобрено средств по проектам',colorForLabels.fifthLevel),
            createDataSet('План по соглашению',colorForLabels.sixthLevel),
        ],
        sortingOrder: [
          'План по соглашению', 'Одобрено средств по проектам', 'Утверждено средств по закупкам', 'Акцептовано ПФУ',
          'Законтрактовано', 'Оплачено'
        ]
      };
      elem.datasets = setDataToDataSet(elem.datasets,
      [e.paymentSum,e.contractSum,e.acceptedSum,e.approvedBuySum,e.approvedProjPlanSum,e.agreementPlanSum])
      let s = 0;
      elem.datasets.map((e) => (s += e.data[0]));
      let title;
      if (e.num == e.name) {
        title = e.name;
      } else {
        title = `${e.num} ${e.name}`;
      }

      if (s > 0) res.push({ title, data: elem });
    });
    setByAgreements(res);
  }

  useEffect(async () => {
    setByAgreements([]);
    const budgetResp = await api.get(`/stats/budget?year=${year}`);

    setCofinancing(budgetResp.sf)

    const totalsByPeriod = {
      labels: [''],
      datasets: [
          createDataSet('Оплачено',colorForLabels.firstLevel),
          createDataSet('Законтрактовано',colorForLabels.secondLevel),
          createDataSet('Акцептовано ПФУ',colorForLabels.thirdLevel),
          createDataSet('Утверждено средств по закупкам',colorForLabels.fourthLevel),
          createDataSet('Одобрено средств по проектам',colorForLabels.fifthLevel),
          createDataSet('План по соглашению',colorForLabels.sixthLevel),
      ],
      title: 'Бюджет в млн руб.',
      sortingOrder: [
        'План по соглашению', 'Одобрено средств по проектам', 'Утверждено средств по закупкам', 'Акцептовано ПФУ',
        'Законтрактовано', 'Оплачено'
      ]
    };
    totalsByPeriod.datasets = setDataToDataSet(totalsByPeriod.datasets,
        [
            budgetResp.totals.paymentSum,
            budgetResp.totals.contractSum,
            budgetResp.totals.acceptedSum,
            budgetResp.totals.approvedBuySum,
            budgetResp.totals.approvedProjPlanSum,
            budgetResp.totals.agreementPlanSum
        ])
      const offBudgetTotals = {
        labels: [''],
        datasets: [
          createDataSet('Привлечено средств', colorForLabels.firstLevel),
          createDataSet('План по программе', colorForLabels.sixthLevel),
        ],
        title: 'Внебюджет в млн руб.',
        sortingOrder: ['План по программе', 'Привлечено средств']
      }
      offBudgetTotals.datasets = setDataToDataSet(offBudgetTotals.datasets, [budgetResp.sf.totals.paymentSum, budgetResp.sf.totals.agreementPlanSum])
    setTotals([totalsByPeriod, offBudgetTotals]);

    doByAgreements(budgetResp.byAgreements);
  }, [year]);

  useEffect(async () => {
    setIsLoaded(false);
    setByTypesState(null);
    const budgetRespForBar = await api.get(`/stats/budget?year=${year}`);
    budgetRespForBar.byTypes = budgetRespForBar.byTypes.map((e) => ({...e, projCount: e.projCount ? e.projCount : 0})).sort((a, b) => a.projCount - b.projCount)
    const typesLastIndex = budgetRespForBar.byTypes.length - 1;
    byTypes.datasets[0].data = Array(budgetRespForBar.byTypes.length).fill(0);
    byTypes.datasets[1].data = Array(budgetRespForBar.byTypes.length).fill(0);
    byTypes.datasets[0].data.forEach((e, i) => {
      byTypes.datasets[0].data[i] = Math.trunc(budgetRespForBar.byTypes[typesLastIndex - i]?.approvedProjPlanSum) / 1000000;
      byTypes.datasets[1].data[i] = Math.trunc(budgetRespForBar.byTypes[typesLastIndex - i]?.approvedProjPlanSfSum) / 1000000;
    });
    byTypes.labels = Array(budgetRespForBar.byTypes.length).fill('');
    byTypes.labels.forEach((e, i) => {
      byTypes.labels[i] = splitStringEveryNCharsBySpace(`${budgetRespForBar.byTypes[typesLastIndex - i]?.name}, ${
        budgetRespForBar.byTypes[typesLastIndex - i]?.projCount || 0
      } шт.`, 20);
    });
    setByTypesState(byTypes);
    byDivisionsBuild()
    setIsLoaded(true);
  }, [year]);

  const debouncedTimeout = useRef(null);
  const getDivisionsCounter = useRef(0)
  useEffect(() => {
    setIsLoadingDivisions(true)
    clearTimeout(debouncedTimeout.current)
    debouncedTimeout.current = setTimeout(async () => {
      if (isLoaded) {
        getDivisionsCounter.current += 1;
        await byDivisionsBuild();
        getDivisionsCounter.current -= 1;
        if(getDivisionsCounter.current === 0){
          setIsLoadingDivisions(false)
        }
      }
    }, 800)
  }, [grantCheck, outBudgetCheck]);

  const byDivisionsBuild = async () => {
    const data = await api.get(`/stats/buyDivisions?year=${year}`);
    data.result = data.result
    .filter((e) =>
      grantCheck && outBudgetCheck ?
      e.plan > 0 || e.fact > 0
      : grantCheck ?
      e.plan_fb > 0 || e.fact_fb > 0
      : outBudgetCheck ?
      e.plan_sf > 0 || e.fact_sf > 0
      : null
    )
    .sort((a, b) =>
      grantCheck && outBudgetCheck ?
      a.fact - b.fact
      : grantCheck ?
      a.fact_fb - b.fact_fb
      : outBudgetCheck ?
      a.fact_sf - b.fact_sf
      : null
    )
    const divisionsLastIndex = data.result.length - 1;
    byDivisions.datasets[0].data = Array(data.result.length).fill(0);
    byDivisions.datasets[1].data = Array(data.result.length).fill(0);
    byDivisions.labels = Array(data.length).fill('');
    byDivisions.datasets[0].data.forEach((e, i) => {
      byDivisions.datasets[0].data[i] =
      grantCheck && outBudgetCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.fact) / 1000000
      : grantCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.fact_fb) / 1000000
      : outBudgetCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.fact_sf) / 1000000
      : 0
      byDivisions.datasets[1].data[i] =
      grantCheck && outBudgetCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.plan) / 1000000
      : grantCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.plan_fb) / 1000000
      : outBudgetCheck ?
      Math.trunc(data.result[divisionsLastIndex - i]?.plan_sf) / 1000000
      : 0
    });
    data.result.forEach((e, i) => {
      byDivisions.labels[i] = splitStringEveryNCharsBySpace(`${data.result[divisionsLastIndex - i]?.name}`, 26);
    });
    setByDivisionsState(byDivisions);
  }

  const diagramsForCofinancing = useMemo(() => {
    if(cofinancing){
      const internal = {
        labels: [''],
        datasets: [
          createDataSet('Оплачено', colorForLabels.firstLevel),
          createDataSet('Утвержденный план', colorForLabels.sixthLevel),
        ],
        title: 'Собственное софинансирование в млн руб.',
        sortingOrder: ['Утвержденный план' , 'Оплачено']
      }
      internal.datasets = setDataToDataSet(internal.datasets, [cofinancing.internal.paymentSum, cofinancing.internal.approvedProjPlanSum])
      const external = {
        labels: [''],
        datasets: [
          createDataSet('Подписано актов', colorForLabels.firstLevel),
          createDataSet('Поступления по договорам', colorForLabels.fourthLevel),
          createDataSet('Заключено договоров', colorForLabels.sixthLevel),
        ],
        title: 'Поступления от НИОКТР в млн руб.',
        sortingOrder: ['Заключено договоров', 'Поступления по договорам', 'Подписано актов']
      }
      external.datasets = setDataToDataSet(external.datasets, [cofinancing.external.paymentActSum, cofinancing.external.paymentOrderSum, cofinancing.external.contractSum])
      return {internal, external}
    }
  }, [cofinancing])

  return (
    <div className={styles.budget}>
      <p className={styles.fw_600}>Период</p>
      <div className={styles.period}>
        <Select year={year} years={years} onChange={(e) => setYear(e.value)} />
      </div>
      <Row>
        <Col xs={6}>
          <h2 style={{fontSize: 20, textAlign: 'left'}}>Исполнение бюджета из средств гранта</h2>
        </Col>
        <Col xs={6}>
          <h2 style={{fontSize: 20, textAlign: 'left'}}>Софинансирование</h2>
        </Col>
      </Row>
      <div className='d-flex'>
        {totals.map((item, i) => <StackedBar key={i} title={item.title} labels data={item} isTotal/>)}
      </div>

      <Row className={styles.detalization}>
        {!isNew && (
          <Col className={styles.detalizationColumn} xs={6}>
            <Accordion title="Детализация по соглашению с Минобрнауки, млн руб.">
              <div className={styles.stackeds}>
                <div className={styles.agreementsBlock}>
                  {byAgreements.map((e, i) => (
                    <StackedBar key={i} title={e.title} data={e.data} labels/>
                  ))}
                </div>
              </div>
            </Accordion>
          </Col>
        )}
        <Col className={styles.detalizationColumn} xs={6}>
          <Accordion title='Детализация по внебюджету, млн руб.'>
            {diagramsForCofinancing && <div className={styles.stackeds}>
                <Row className='w-100 mb-5'>
                  <StackedBar title={diagramsForCofinancing.internal.title} data={diagramsForCofinancing.internal} labels />
                  <StackedBar title={diagramsForCofinancing.external.title} data={diagramsForCofinancing.external} labels />
                </Row>
              </div>}
          </Accordion>
        </Col>
      </Row>
      <LoadingTable loadingObject={{isLoaded}}>
        <div className='tab-budget-bars-container'>
          <div className='tab-budget-bar'>
            <h3
              className="left-aligned-no-icon first-bar-title"
              style={{ fontSize: 20, fontWeight: 600, fontFamily: 'Open Sans' }}
            >
              Распределение средств по типам проектов, млн руб.
            </h3>
            {byTypesState && <DefaultBar data={byTypesState} />}
          </div>
          <div className='tab-budget-bar'>
            <h3
              className="left-aligned-no-icon"
              style={{ marginBottom: 13, fontSize: 20, fontWeight: 600, fontFamily: 'Open Sans' }}
            >
              Распределение средств по структурным подразделениям университета, млн руб.
            </h3>
            <div style={{ display: 'flex', columnGap: 24, position: 'relative', zIndex: 1 }}>
              <Form.Check
                checked={grantCheck}
                onChange={() => setGrantCheck(!grantCheck)}
                type="checkbox"
                label="Из гранта"
              />
              <Form.Check
                checked={outBudgetCheck}
                onChange={() => setOutBudgetCheck(!outBudgetCheck)}
                type="checkbox"
                label="Из внебюджета"
              />
            </div>
              <LoadingTable loadingObject={{isLoading: isLoadingDivisions}}>
                {byDivisionsState && <ColorsBar data={byDivisionsState} />}
              </LoadingTable>
          </div>
        </div>
      </LoadingTable>
    </div>
  );
}
